import { Column } from './Column';
import { Sorting } from './Sorting';
import { Filter } from './Filter';
import { IActions } from './IActions';
import { PagingOptions } from './PagingOptions';
import { EfApiActions } from './EfApiActions';
import { OdataApiActions } from './OdataApiActions';
import { AxiosInstance } from 'axios';
import { ITranslation } from './ITranslation';
import { GermanTranslation } from './Translations/GermanTranslation';
import { EnglishTranslation } from './Translations/EnglishTranslation';
import { FrenchTranslation } from './Translations/FrenchTranslation';
import { QueryBuilder } from 'odata-query-builder';

export class Config {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public key: (row: any) => string | number;
  public columns: Column[] | undefined;
  public initialSorting: Sorting[];
  public pagingOptions: PagingOptions;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public rowStyling: ((row: any) => { [key: string]: boolean }) | undefined;
  public apiActions: IActions | undefined;
  public translations: ITranslation[] = new Array<ITranslation>();
  public permanentFilters: Array<Filter>;

  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    key: (row: any) => string | number,
    columns?: Column[],
    initialSorting?: Sorting[],
    pagingOptions: PagingOptions = new PagingOptions(25),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rowStyling?: (row: any) => { [key: string]: boolean },
    apiActions?: IActions,
    permanentFilters?: Array<Filter>
  ) {
    this.key = key;
    this.columns = columns;
    this.initialSorting = initialSorting || [new Sorting('')];
    this.pagingOptions = pagingOptions;
    this.rowStyling = rowStyling;
    this.apiActions = apiActions;
    this.permanentFilters = permanentFilters || [];
    this.translations.push(
      new GermanTranslation(),
      new EnglishTranslation(),
      new FrenchTranslation()
    );
  }

  public withEfApiActions(axios: AxiosInstance, entityName: string, apiRoute = '/api/'): Config {
    this.apiActions = new EfApiActions(axios, apiRoute, entityName, this.key);
    return this;
  }

  public withOdataApiActions(
    axios: AxiosInstance,
    entityName: string,
    apiRoute = '/odata/',
    customConfigCallback?: (queryBuilder: QueryBuilder) => QueryBuilder | undefined
  ): Config {
    this.apiActions = new OdataApiActions(
      axios,
      apiRoute,
      entityName,
      this.key,
      customConfigCallback
    );
    return this;
  }

  public addTranslation(translation: ITranslation): Config {
    const foundIndex = this.translations.findIndex((x) => x.language === translation.language);
    if (foundIndex === -1) {
      this.translations.push(translation);
    } else {
      this.translations[foundIndex] = translation;
    }
    return this;
  }
}
